import { MenuFoldOutlined, MenuUnfoldOutlined, CoffeeOutlined, ShoppingOutlined, EnvironmentOutlined, TagsOutlined, AppstoreOutlined, ShoppingCartOutlined, UserOutlined, HomeOutlined, FileTextOutlined, ClockCircleOutlined, CarOutlined, LogoutOutlined, InboxOutlined, BankOutlined, InstagramOutlined, FacebookOutlined, SettingOutlined, ShopOutlined, PercentageOutlined, ToolOutlined, GiftOutlined, ApiOutlined, TeamOutlined, MobileOutlined } from '@ant-design/icons';
import { Button, Drawer, Layout, Menu, theme } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

const { Sider } = Layout;

interface SidebarProps {
    collapsed: boolean;
    setCollapsed: (collapsed: boolean) => void;
    isMobile: boolean;
    mobileMenuVisible: boolean;
    setMobileMenuVisible: (visible: boolean) => void;
}

const menuItems = [
    {
        key: '/coffee',
        label: 'Quản lý hạt cà phê',
        icon: <CoffeeOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: '/bottled-drink',
        label: 'Quản lý đồ uống đóng chai',
        icon: <ShoppingOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: '/coffee-equipment',
        label: 'Quản lý dụng cụ cà phê',
        icon: <ToolOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: '/region',
        label: 'Quản lý vùng trồng',
        icon: <EnvironmentOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: '/collection',
        label: 'Quản lý tuyển tập',
        icon: <AppstoreOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: '/order',
        label: 'Quản lý đơn hàng',
        icon: <ShoppingCartOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: 'invoice-source',
        label: 'Quản lý nguồn tiền',
        icon: <BankOutlined style={{ fontSize: '16px' }} />,
        children: [
            { key: '/invoice-management', label: 'Quản lý hóa đơn', icon: <FileTextOutlined style={{ fontSize: '16px' }} /> },
            { key: '/recipes', label: 'Quản lý công thức', icon: <CoffeeOutlined style={{ fontSize: '16px' }} /> },
            { key: '/ingredient-management', label: 'Quản lý nguyên liệu', icon: <TagsOutlined style={{ fontSize: '16px' }} /> },
        ]
    },
    {
        key: '/purchase-receipts',
        label: 'Phiếu nhập nguyên liệu',
        icon: <ShoppingOutlined style={{ fontSize: '16px' }} />,
    },
    {
        key: '/cukcuk/mapping',
        label: 'Cấu hình mapping CUKCUK',
        icon: <SettingOutlined style={{ fontSize: '16px' }} />,
    },
    {
        key: '/user',
        label: 'Quản lý người dùng',
        icon: <UserOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: 'employee-management-source',
        label: 'Quản lý nhân viên',
        icon: <TeamOutlined style={{ fontSize: '16px' }} />,
        children: [
            {
                key: '/employee-role-management',
                label: 'Quản lý nhân sự & phân quyền',
                icon: <TeamOutlined style={{ fontSize: '16px' }} />,
            },
            {
                key: '/schedule-registration-engine',
                label: 'Quản lý lịch làm việc',
                icon: <ClockCircleOutlined style={{ fontSize: '16px' }} />,
            },
        ]
    },
    {
        key: '/miniapp-management',
        label: 'Quản lý Mini App',
        icon: <MobileOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: '/home-management',
        label: 'Quản lý trang chủ',
        icon: <HomeOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: 'content',
        label: 'Quản lý nội dung',
        icon: <FileTextOutlined style={{ fontSize: '16px' }} />,
        children: [
            { key: '/messages', label: 'Quản lý tin truyền thông', icon: <InboxOutlined style={{ fontSize: '16px' }} /> },
            { key: '/zalo-templates', label: 'Quản lý template Zalo', icon: <ApiOutlined style={{ fontSize: '16px' }} /> },
            { key: '/broadcasts', label: 'Quản lý broadcast', icon: <InboxOutlined style={{ fontSize: '16px' }} /> },
            { key: '/gifts', label: 'Quản lý quà tặng', icon: <GiftOutlined style={{ fontSize: '16px' }} /> },
        ]
    },
    {
        key: '/business-hours',
        label: 'Quản lý giờ làm việc',
        icon: <ClockCircleOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: '/shipping',
        label: 'Quản lý vận chuyển',
        icon: <CarOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: '/stores',
        label: 'Quản lý cửa hàng',
        icon: <ShopOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: '/vat-management',
        label: 'Quản lý thuế VAT',
        icon: <PercentageOutlined style={{ fontSize: '16px' }} />
    },
    {
        key: 'menu',
        label: 'Quản lý thực đơn',
        icon: <FileTextOutlined style={{ fontSize: '16px' }} />,
        children: [
            { key: '/dishes', label: 'Quản lý món ăn', icon: <CoffeeOutlined style={{ fontSize: '16px' }} /> },
            { key: '/groups', label: 'Quản lý nhóm món', icon: <TagsOutlined style={{ fontSize: '16px' }} /> },
            { key: '/types', label: 'Quản lý loại món', icon: <AppstoreOutlined style={{ fontSize: '16px' }} /> },
            { key: '/customization', label: 'Quản lý tùy chọn', icon: <SettingOutlined style={{ fontSize: '16px' }} /> },
            { key: '/cukcuk/menu', label: 'Menu CUKCUK', icon: <CoffeeOutlined style={{ fontSize: '16px' }} /> },
            { key: '/cukcuk/hoa-don', label: 'Hóa đơn CUKCUK', icon: <FileTextOutlined style={{ fontSize: '16px' }} /> },
        ]
    },
    // {
    //     key: 'social-media',
    //     label: 'Quản lý mạng xã hội',
    //     icon: <BankOutlined style={{ fontSize: '16px' }} />,
    //     children: [
    //         {
    //             key: '/facebook',
    //             label: 'Quản lý facebook',
    //             icon: <FacebookOutlined style={{ fontSize: '16px' }} />,
    //         },
    //         { key: '/instagram', label: 'Quản lý instagram', icon: <InstagramOutlined style={{ fontSize: '16px' }} /> },
    //         // { key: '/tiktok', label: 'Quản lý tiktok', icon: <TiktokOutlined style={{ fontSize: '16px' }} /> },
    //     ]
    // },
];

const Sidebar = ({ collapsed, setCollapsed, isMobile, mobileMenuVisible, setMobileMenuVisible }: SidebarProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { token } = theme.useToken();

    const handleLogout = () => {
        localStorage.removeItem('isAuthenticated8Am');
        navigate('/login');
    };

    const logoutMenuItem = {
        key: 'logout',
        label: 'Đăng xuất',
        icon: <LogoutOutlined style={{ fontSize: '16px' }} />,
    };

    if (isMobile) {
        return (
            <Drawer
                title="8am Coffee Admin"
                placement="left"
                onClose={() => setMobileMenuVisible(false)}
                open={mobileMenuVisible}
                bodyStyle={{ padding: 0 }}
                width={280}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                }}>
                    <Menu
                        theme="light"
                        mode="inline"
                        selectedKeys={[location.pathname]}
                        items={menuItems}
                        onSelect={({ key }) => {
                            navigate(key);
                            setMobileMenuVisible(false);
                        }}
                        style={{
                            flex: 1,
                            borderRight: 0
                        }}
                    />
                    <Menu
                        theme="light"
                        mode="inline"
                        selectedKeys={[]}
                        items={[logoutMenuItem]}
                        onSelect={() => handleLogout()}
                        style={{
                            borderRight: 0,
                            borderTop: `1px solid ${token.colorBorder}`,
                        }}
                    />
                </div>
            </Drawer>
        );
    }

    return (
        <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            theme="light"
            style={{
                overflow: 'hidden',
                height: '100vh',
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                boxShadow: '2px 0 8px 0 rgba(29,35,41,.05)',
                transition: 'all 0.2s',
                zIndex: 999
            }}
            width={220}
        >
            <div style={{
                height: '64px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderBottom: `1px solid ${token.colorBorder}`,
                color: token.colorPrimary,
                fontSize: '18px',
                fontWeight: 'bold',
                overflow: 'hidden',
                transition: 'all 0.3s ease'
            }}>
                {!collapsed ? (
                    <span style={{ opacity: collapsed ? 0 : 1, transition: 'opacity 0.3s' }}>
                        8am Coffee Admin
                    </span>
                ) : (
                    <CoffeeOutlined style={{ fontSize: '24px' }} />
                )}
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: 'calc(100% - 64px)',
            }}>
                <Menu
                    theme="light"
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    items={menuItems}
                    onSelect={({ key }) => navigate(key)}
                    style={{
                        flex: 1,
                        borderRight: 0,
                        padding: '16px 0',
                        overflow: 'auto'
                    }}
                />
                <Menu
                    theme="light"
                    mode="inline"
                    selectedKeys={[]}
                    items={[logoutMenuItem]}
                    onSelect={() => handleLogout()}
                    style={{
                        borderRight: 0,
                        borderTop: `1px solid ${token.colorBorder}`,
                        padding: '16px 0'
                    }}
                />
            </div>
        </Sider>
    );
};

export default Sidebar;
